// @ vendor
const isEmpty = require('lodash/lang/isEmpty');

// @ commons
const { getLanguage } = require('core/i18n').i18n;
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { addAcceptedText } = require('../../insuranceUtilities/addAcceptedTextHelper');

// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const { linkClient, linkClientSuccessInitialState, cancelSimulation, basicPlanAcceptanceModal } = require('./insuranceRequestWizardStep3');
const { requestInsuranceCurrentPricing, setPaymentAccount, getPaymentAccount, getAddressTypeList, getMortgageBanks } = require('./insuranceRequestWizardStep4');
const { getDocument, sendBudgetEmail, checkReadDocument } = require('./insuranceRequestWizardStep5');
const { updateConsents } = require('actions/gdprConsents');

// @ constants
const {
    WIZARD_REQUEST_RESPONSE_OPTIONS,
    PLANS, COVERAGES_NAMES,
    PLANS: { BASIC }
} = require('../../insuranceConstants/insuranceRequestHome');
const { INSURANCES_TYPE: { HOME_NOT_RELATED, HOME_MORTGAGE_RELATED } } = require('../../insuranceConstants/insuranceRequestTypes');
const { FIRST_STEP, SECOND_STEP, THIRD_STEP, FOURTH_STEP, FIFTH_STEP, SIXTH_STEP } = require('constants/index');
const {
    INSURANCE_REQUEST_CHANGE_ERROR_POSTAL_CODE,
    INSURANCE_REQUEST_CHANGE_ERROR_POPULATION,
    INSURANCE_REQUEST_CLEAR_POSTAL_CODE_ERROR,
    INSURANCE_REQUEST_WIZARD_LOAD_STEP,
    INSURANCE_REQUEST_WIZARD_SET_IS_LOADING_FROM_PUBLIC,
    INSURANCE_REQUEST_WIZARD_SET_VISIBLE_STEP,
    INSURANCE_REQUEST_WIZARD_VALIDATE_STEP,
    INSURANCE_REQUEST_WIZARD_WILL_CANCEL,
    INSURANCE_REQUEST_WIZARD_SET_DATA,
    INSURANCE_REQUEST_WIZARD_CLEAR,
    INSURANCE_REQUEST_POST_WIZARD_SUCCESS,
    INSURANCE_REQUEST_POST_WIZARD_ERROR,
    INSURANCE_REQUEST_COVERAGES_QUOTATION_REQUEST,
    INSURANCE_REQUEST_COVERAGES_QUOTATION_SUCCESS,
    INSURANCE_REQUEST_COVERAGES_QUOTATION_FAILURE,
    INSURANCE_REQUEST_GET_COVERAGES_AND_PLANS_TABLE_REQUEST,
    INSURANCE_REQUEST_GET_COVERAGES_AND_PLANS_TABLE_SUCCESS,
    INSURANCE_REQUEST_GET_COVERAGES_AND_PLANS_TABLE_FAILURE,
    INSURANCE_REQUEST_COVERAGES_DETAIL_BASIC_DATA_REQUEST,
    INSURANCE_REQUEST_COVERAGES_DETAIL_BASIC_DATA_SUCCESS,
    INSURANCE_REQUEST_COVERAGES_DETAIL_MEDIUM_DATA_REQUEST,
    INSURANCE_REQUEST_COVERAGES_DETAIL_MEDIUM_DATA_SUCCESS,
    INSURANCE_REQUEST_COVERAGES_DETAIL_HIGH_DATA_REQUEST,
    INSURANCE_REQUEST_COVERAGES_DETAIL_HIGH_DATA_SUCCESS,
    INSURANCE_REQUEST_COVERAGES_DETAIL_DATA_FAILURE,
    INSURANCE_REQUEST_SELECT_PLAN_REQUEST,
    INSURANCE_REQUEST_SELECT_PLAN_SUCCESS,
    INSURANCE_REQUEST_SELECT_PLAN_FAILURE,
    INSURANCE_REQUEST_SELECT_POPULATION_REQUEST,
    INSURANCE_REQUEST_SELECT_POPULATION_SUCCESS,
    INSURANCE_REQUEST_SELECT_POPULATION_FAILURE,
} = require('../../insuranceConstants/actionTypes');
const {
    INSURANCE_NO_RELATED_LEGAL_CHECK,
    INSURANCE_USABILITY_IMPROVEMENTS,
    PRE_CONTRACTUAL_NO_RELATED_INSURANCE_MAIL,
    STANDALONE_RELATED_INSURANCE,
} = require('constants/flagBasedFeatures');

const loadStep = (step, data) => ({
    type: INSURANCE_REQUEST_WIZARD_LOAD_STEP,
    data: {
        ...data,
        step
    }
});

const setVisibleStep = step => ({
    type: INSURANCE_REQUEST_WIZARD_SET_VISIBLE_STEP,
    data: {
        step
    }
});

const setIsLoadingFromPublic = () => ({
    type: INSURANCE_REQUEST_WIZARD_SET_IS_LOADING_FROM_PUBLIC,
})

const clearPostalCodeError = () => ({
    type: INSURANCE_REQUEST_CLEAR_POSTAL_CODE_ERROR,
})

const validateWithUI = step => ({
    type: INSURANCE_REQUEST_WIZARD_VALIDATE_STEP,
    data: {
        step
    }
});

const setWillCancel = willCancel => ({
    type: INSURANCE_REQUEST_WIZARD_WILL_CANCEL,
    data: {
        willCancel
    }
});

const setData = (step, data) => ({
    type: INSURANCE_REQUEST_WIZARD_SET_DATA,
    data: {
        step,
        ...data
    }
});

const clearRequest = () => ({
    type: INSURANCE_REQUEST_WIZARD_CLEAR
});

const wizardFinalRequest = (response, isCombined = false) => ({
    type: INSURANCE_REQUEST_POST_WIZARD_SUCCESS,
    data: { response, isCombined }
});

const wizardFinalRequestError = (error = '', isCombined = false) => ({
    type: INSURANCE_REQUEST_POST_WIZARD_ERROR,
    data: { error, isCombined }
});

const requestQuotationInProgress = () => ({
    type: INSURANCE_REQUEST_COVERAGES_QUOTATION_REQUEST
});

const requestQuotationSuccess = data => ({
    type: INSURANCE_REQUEST_COVERAGES_QUOTATION_SUCCESS,
    data
});

const requestQuotationFailure = error => ({
    type: INSURANCE_REQUEST_COVERAGES_QUOTATION_FAILURE,
    data: { error }
});

const coveragesAndPlansDataInProgress = () => ({
    type: INSURANCE_REQUEST_GET_COVERAGES_AND_PLANS_TABLE_REQUEST
});

const coveragesAndPlansDataSuccess = data => ({
    type: INSURANCE_REQUEST_GET_COVERAGES_AND_PLANS_TABLE_SUCCESS,
    data
});

const coveragesAndPlansDataFailure = error => ({
    type: INSURANCE_REQUEST_GET_COVERAGES_AND_PLANS_TABLE_FAILURE,
    data: { error }
});

const coveragesAndPlansDetailsBasicInProgress = () => ({
    type: INSURANCE_REQUEST_COVERAGES_DETAIL_BASIC_DATA_REQUEST,
});

const coveragesAndPlansDetailsBasicSuccess = data => ({
    type: INSURANCE_REQUEST_COVERAGES_DETAIL_BASIC_DATA_SUCCESS,
    data
});

const coveragesAndPlansDetailsMediumInProgress = () => ({
    type: INSURANCE_REQUEST_COVERAGES_DETAIL_MEDIUM_DATA_REQUEST,
});

const coveragesAndPlansDetailsMediumSuccess = data => ({
    type: INSURANCE_REQUEST_COVERAGES_DETAIL_MEDIUM_DATA_SUCCESS,
    data
});

const coveragesAndPlansDetailsHighInProgress = () => ({
    type: INSURANCE_REQUEST_COVERAGES_DETAIL_HIGH_DATA_REQUEST,
});

const coveragesAndPlansDetailsHighSuccess = data => ({
    type: INSURANCE_REQUEST_COVERAGES_DETAIL_HIGH_DATA_SUCCESS,
    data
});

const coveragesAndPlansDetailsFailure = error => ({
    type: INSURANCE_REQUEST_COVERAGES_DETAIL_DATA_FAILURE,
    data: { error }
});

const requestSelectPlanInProgress = () => ({
    type: INSURANCE_REQUEST_SELECT_PLAN_REQUEST
});

const requestSelectPlanSuccess = plan => ({
    type: INSURANCE_REQUEST_SELECT_PLAN_SUCCESS,
    data: {
        plan
    }
});

const requestSelectPlanFailure = error => ({
    type: INSURANCE_REQUEST_SELECT_PLAN_FAILURE,
    data: { error }
});

const requestSelectPopulationInProgress = () => ({
    type: INSURANCE_REQUEST_SELECT_POPULATION_REQUEST
});

const requestSelectPopulationSuccess = population => ({
    type: INSURANCE_REQUEST_SELECT_POPULATION_SUCCESS,
    data: {
        population
    }
});

const requestSelectPopulationFailure = error => ({
    type: INSURANCE_REQUEST_SELECT_POPULATION_FAILURE,
    data: { error }
});

const changeErrorPostalCode = () => ({
    type: INSURANCE_REQUEST_CHANGE_ERROR_POSTAL_CODE
});

const changeErrorPopulation = () => ({
    type: INSURANCE_REQUEST_CHANGE_ERROR_POPULATION
});

const isMixedInsuranceBonus = (getState) => {
    const isEnabledFF = getState().flagBasedFeatures.get(STANDALONE_RELATED_INSURANCE);
    const contractNumber = getState().insuranceChosenMortgage.getIn(['chosenMortgage', 'contractNumber']);

    return isEnabledFF && contractNumber !== undefined;
}

const hireInsurance = (dispatch, getState, requestData) => {
    const currentState = getState().insuranceRequestState.get('data');
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const isCombined = isMixedInsuranceBonus(getState);

    dispatch(wizardFinalRequest(WIZARD_REQUEST_RESPONSE_OPTIONS.IS_FETCHING));

    return APIPost(
        dispatch,
        apiURLBuilder.getURL('insuranceRequestApply', { id: currentState.get('id'), lang: getLanguage().toUpperCase() }),
        requestData
    )
        .then(() => {
            dispatch(wizardFinalRequest(WIZARD_REQUEST_RESPONSE_OPTIONS.SUCCESS, isCombined));
            if (!__CONTACT_CENTER__ && !immFlagBasedFeatures.get(PRE_CONTRACTUAL_NO_RELATED_INSURANCE_MAIL)) {
                dispatch(sendBudgetEmail());
            }
        })
        .catch(response => {
            if (!!response.body) {
                const error = response.body;
                dispatch(wizardFinalRequestError(error, isCombined));
            }
            else {
                dispatch(wizardFinalRequestError(undefined, isCombined));
            }
        });
};


const validateWizzardSuccess = () => (dispatch, getState) => {
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const callback = (dispatch, getState, dataToken) => {
        const requestData = {
            query: {
                dataToken
            }
        };

        if (immFlagBasedFeatures.get(INSURANCE_NO_RELATED_LEGAL_CHECK)) {
            requestData['query']['acceptedText'] = addAcceptedText();
        }

        dispatch(updateConsents(dataToken))
            .then(() => hireInsurance(dispatch, getState, requestData))
            .catch(() => hireInsurance(dispatch, getState, requestData));
    };

    new Promise(() => {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

const validateStep = (step, basicPlanAccepted) => (dispatch, getState) => {
    const immFlagBasedFeatures = getState().flagBasedFeatures;

    const stepListNumber = step - 1;
    dispatch(validateWithUI(step));
    const immStep = getState().insuranceRequestWizard.getIn(['steps', stepListNumber]);
    const isValidUI = immStep.get('validUI');
    const insuranceUsabilityImprovementsFlag = !!immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS);
    const isBasicPlan = immStep.get('insurancePlan') === BASIC;
    const selectPlanValidation = !insuranceUsabilityImprovementsFlag ?
        isValidUI && step === FOURTH_STEP :
        isValidUI && step === FOURTH_STEP && (isBasicPlan && basicPlanAccepted || !isBasicPlan);

    if (!isValidUI) {
        scrollToTop();
    }

    if(step === FOURTH_STEP && isBasicPlan && !basicPlanAccepted) {
        dispatch(basicPlanAcceptanceModal());
    }

    if (selectPlanValidation) {
        const simulationToken = immStep.getIn(['quotationData', 'simulationToken']);
        const currentStateData = getState().insuranceRequestState.get('data');
        const islinkingSuccess = immStep.get('islinkingSuccess');
        if (!islinkingSuccess) {
            if (currentStateData !== null && !currentStateData.isEmpty()) {
                dispatch(cancelSimulation(simulationToken, stepListNumber));
            } else {
                dispatch(linkClient(simulationToken));
            }
        }
    }

    if (isValidUI && step === FIFTH_STEP) {
        dispatch(setPaymentAccount());
    }

    if (step === SIXTH_STEP) {
        const isValid = immStep.get('valid');
        const isAcceptedConditions = immStep.get('acceptedConditions');
        if (isValid && isAcceptedConditions) {
            dispatch(validateWizzardSuccess());
        }
    }
};

const insuranceSelectPlan = (plan, selectedFromDetailTable) => (dispatch, getState) => {
    const immStep = getState().insuranceRequestWizard.getIn(['steps', THIRD_STEP]);

    if (!immStep.get('isFetchingSelectPlan')) {
        dispatch(requestSelectPlanInProgress());

        const params = {
            query: {
                plan,
                simulationToken: immStep.getIn(['quotationData', 'simulationToken'])
            }
        };

        const successRequestCallback = () => {
            dispatch(requestSelectPlanSuccess(plan))
            selectedFromDetailTable && dispatch(validateStep(FOURTH_STEP))
        }

        return APIPost({
            dispatch,
            endpoint: 'insuranceRequestSelectPlan',
            params
        })
            .then(successRequestCallback)
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestSelectPlanFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const getPopulationData = (postalCode, ignoreFetching) => (dispatch, getState) => {
    const immStep2 = getState().insuranceRequestWizard.getIn(['steps', SECOND_STEP]);

    if (ignoreFetching || !immStep2.get('isFetchingSelectPopulation')) {
        dispatch(requestSelectPopulationInProgress());
        const params = {
            postalCode
        };

        return APIGet({
            dispatch,
            endpoint: 'insuranceRequestPopulation',
            params
        })
            .then((response) => {
                dispatch(requestSelectPopulationSuccess(response.data));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestSelectPopulationFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const getCoveragesAndPlansData = propertyUsage => (dispatch, getState) => {
    dispatch(coveragesAndPlansDataInProgress());

    const immStep2 = getState().insuranceRequestWizard.getIn(['steps', SECOND_STEP]);
    const immStep3 = getState().insuranceRequestWizard.getIn(['steps', THIRD_STEP]);
    const insuranceType = (isMixedInsuranceBonus(getState))
        ? HOME_MORTGAGE_RELATED
        : HOME_NOT_RELATED;

    const params = {
        query: {
            homeInsuranceType: insuranceType,
            propertyCharacter: immStep2.get('propertyCharacter'),
            propertyUsage,
            simulationToken: immStep3.getIn(['quotationData', 'simulationToken'])
        }
    };

    return APIGet({
        dispatch,
        endpoint: 'insuranceRequestCoveragesAndPlans',
        params
    })
        .then(response => {
            dispatch(coveragesAndPlansDataSuccess(response.data));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(coveragesAndPlansDataFailure(response.error));
            }
        })
};

const getCoveragesAndPlansDetailsData = (usage, character, plan = PLANS.HIGH, insuranceType = HOME_NOT_RELATED) => (dispatch, getState) => {
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const nextPlan = plan === PLANS.HIGH ? PLANS.MEDIUM : PLANS.BASIC;
    const immStep = getState().insuranceRequestWizard.getIn(['steps', THIRD_STEP]);
    const simulationToken = immStep.getIn(['quotationData', 'simulationToken']);
    const homeInsuranceType = (isMixedInsuranceBonus(getState))
        ? HOME_MORTGAGE_RELATED
        : insuranceType;

    const actions = {
        HIGH: {
            inProgress: coveragesAndPlansDetailsHighInProgress,
            success: coveragesAndPlansDetailsHighSuccess
        },
        MEDIUM: {
            inProgress: coveragesAndPlansDetailsMediumInProgress,
            success: coveragesAndPlansDetailsMediumSuccess
        },
        BASIC: {
            inProgress: coveragesAndPlansDetailsBasicInProgress,
            success: coveragesAndPlansDetailsBasicSuccess
        }
    };

    dispatch(actions[plan].inProgress());
    const params = {
        query: {
            propertyUsage: usage,
            insurancePlan: plan,
            propertyCharacter: character,
            homeInsuranceType,
            simulationToken
        }
    };

    if (immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS)) {
        params['header'] = {
            version: '2',
        }
    }

    return APIGet({
        dispatch,
        endpoint: 'insuranceRequestCoveragesAndPlansDetails',
        params
    })
        .then(response => {
            dispatch(actions[plan].success(response.data));
            if (nextPlan !== plan) {
                dispatch(getCoveragesAndPlansDetailsData(usage, character, nextPlan, homeInsuranceType));
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(coveragesAndPlansDetailsFailure(response.error));
            } else {
                throw response;
            }
        });
};

const getPopulationLabel = immStep2 => {
    const populationValue = immStep2.get('populationValue');
    if (populationValue) {
        const immPopulation = immStep2.get('populationOptions').
            find(immPopulation => populationValue === immPopulation.get('value'));
        return immPopulation.get('label');
    }
}

const getQuotationData = hasSimulationChanged => (dispatch, getState) => {
    const immStep2 = getState().insuranceRequestWizard.getIn(['steps', SECOND_STEP]);
    const immStep3 = getState().insuranceRequestWizard.getIn(['steps', THIRD_STEP]);
    const insuranceType = (isMixedInsuranceBonus(getState))
        ? HOME_MORTGAGE_RELATED
        : null;

    const populationLabel = getPopulationLabel(immStep2);
    const params = {
        query: {
            insuranceType,
            "continent": immStep2.get('continent'),
            "content": immStep2.get('content'),
            "postalCode": immStep2.get('postalCode'),
            "population": populationLabel,
            "size": immStep2.get('size'),
            "propertyCharacter": immStep2.get('propertyCharacter'),
            "propertyType": immStep2.get('propertyType'),
            "propertyUsage": immStep2.get('propertyUsage')
        }
    };

    if (__CONTACT_CENTER__) {
        const selectedPlan = immStep3.get('insurancePlan');

        if (!!selectedPlan && !immStep3.get('coveragePlanModal').isEmpty() && immStep3.get('isQuotationDataChanged')) {
            const planCoverages = immStep3.getIn(['coveragePlanModal', selectedPlan.toUpperCase()]);
            const coveragesWithChanges = planCoverages.filter(coverage => coverage.get('hasChanged') || coverage.get('changed'));
            let fields = {};

            coveragesWithChanges.forEach(coverage => {
                if (coverage.get('hasChanged')) {
                    fields[COVERAGES_NAMES[coverage.get('name')]] = coveragesWithChanges.get(coverage.get('name')).get('currentValue');
                } else if (coverage.get('changed')) {
                    fields[COVERAGES_NAMES[coverage.get('name')]] = coveragesWithChanges.get(coverage.get('name')).get('defaultValue');
                }
            });

            params.query.guaranteeInformation = {
                ...fields
            };
        }
    }

    dispatch(requestQuotationInProgress());

    return APIPost({
        dispatch,
        endpoint: 'insuranceRequestQuotation',
        params
    })
        .then(response => {
            dispatch(requestQuotationSuccess(response.data));

            if (__CONTACT_CENTER__) {
                dispatch(getCoveragesAndPlansData(immStep2.get('propertyUsage')));
                dispatch(getCoveragesAndPlansDetailsData(
                    immStep2.get('propertyUsage'),
                    immStep2.get('propertyCharacter')
                ))
            }

            if (immStep3.get('insurancePlan')) {
                if (hasSimulationChanged) {
                    dispatch(requestSelectPlanSuccess(''));
                } else {
                    insuranceSelectPlan(immStep3.get('insurancePlan'))(dispatch, getState);
                }
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(requestQuotationFailure(response.error));
            } else {
                throw response;
            }
        });
};

const loadSteps = data => dispatch => {
    if (!isEmpty(data)) {
        dispatch(loadStep(FIRST_STEP, data));
        dispatch(loadStep(SECOND_STEP, data));
        dispatch(loadStep(THIRD_STEP, data));
        dispatch(loadStep(FOURTH_STEP, data));
    }
};

module.exports = {
    cancelSimulation,
    changeErrorPostalCode,
    changeErrorPopulation,
    checkReadDocument,
    clearPostalCodeError,
    clearRequest,
    getAddressTypeList,
    getCoveragesAndPlansData,
    getCoveragesAndPlansDetailsData,
    getDocument,
    getMortgageBanks,
    getPaymentAccount,
    getQuotationData,
    insuranceSelectPlan,
    getPopulationData,
    linkClientSuccessInitialState,
    loadSteps,
    requestInsuranceCurrentPricing,
    setData,
    setIsLoadingFromPublic,
    setVisibleStep,
    setWillCancel,
    validateStep,
    validateWizzardSuccess
};
